import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA_REQUEST,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA_SUCCESS,
} from '../../../../actions/actionTypes';

const defaultState = null;

const detectionLinkAccountId = (state = defaultState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_FETCH_INCIDENT_DATA_SUCCESS: {
      return (
        action.payload.response.data.detectionLink?.account?.accountId ?? null
      );
    }

    case INCIDENT_DETAILS_FETCH_INCIDENT_DATA_REQUEST:
    case INCIDENT_DETAILS_CLEAR:
      return defaultState;

    default:
      return state;
  }
};

export default detectionLinkAccountId;
